import type { Theme } from '@mui/material';

export const styles = {
  loadingButtonWrapper: {
    width: '100%',
    pt: 0.5,
  },

  inputField: {
    marginBottom: 1,
    width: '100%',
  },

  adornmentButton: {
    '&:hover': {
      backgroundColor: 'unset',
    },
  },

  visibilityIcon: (theme: Theme) => ({
    fill: theme.colors.neutral[800],
  }),

  visibilityOffIcon: (theme: Theme) => ({
    fill: theme.colors.neutral[200],
    '&:hover': {
      fill: theme.colors.neutral[400],
    },
  }),

  errorMsg: (theme: Theme) => ({
    textAlign: 'center',
    py: 2,
    color: theme.colors.error[600],

    a: {
      textDecoration: 'none',
      color: theme.colors.info[600],
      fontWeight: '600',
    },
  }),
};
